<!-- 物联三级页面 -->
<template>
  <div class="home animate__animated animate__fadeIn">
    <div class="top">
      <Header />
    </div>
    <div class="banner">
      <!-- <img :src="imgUrl" alt /> -->
      <div class="animate__animated animate__fadeInUp animate__faster">
        <span style="margin-bottom:20px">物联</span>
        <span>改变企业思维模式，实现降低能耗，</span>
        <span>控制生产，提高品质的长久运营</span>
      </div>
    </div>
    <div class="main">
      <div class="main_center">
        <div class="bread">
          <!-- <span style="cursor:pointer" @click="handleHome">首页</span>> -->
          <span @click="handleJiejue" style="cursor:pointer">解决方案</span>> 物联
        </div>
        <div class="title">融合创造价值，创新引领未来</div>
        <div class="text">
          <span>
            工业领域正在进行着一场重大变革。随着大数据，云计算，工业物联，工业4.0和人工智能的出现，数字化转型正在改变企业各个方面的运营模式。我们采用先进、安全的交互技术创建数字化服务，并将它们与工业生产装置紧密联合，能够提供预测分析及其他工具和技术，通过优化企业管理和工厂运营，为客户实现有价值的智能改造。
          </span>
        </div>
        <ul>
          <li
            v-for="(item,index) in imgList"
            :key="index"
            v-bind:style="{ 'background-image': 'url(' + item.url+ ')'}"
          >
            <!-- <div class="image">
              <img :src="item.url" alt />
            </div>-->
            <div class="introduce">
              <span class="theme">{{item.theme}}</span>
              <span class="content" v-html="item.content">{{item.content}}</span>
            </div>
          </li>
        </ul>
        <div class="characteristic">
          <p>特点</p>
          <div class="chara_items">
            <div class="chara_item" v-for="(item,index) in teList" :key="index">
              <img :src="item.url" alt />
              <span style="margin-bottom:21px">{{item.theme}}</span>
              <span style="line-height:25px;">{{item.text}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@components/header";
import Footer from "@components/footer";
export default {
  name: "Iot",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      headerList: [
        { name: "解决方案" },
        { name: "产品中心" },
        { name: "咨询服务" },
        { name: "专长" },
        { name: "了解我们" },
        { name: "加入我们" },
      ],
      jieList: [
        { name: "自动化", link: "" },
        { name: "物联", link: "" },
        { name: "能源", link: "" },
        { name: "环境", link: "" },
      ],
      chanList: [
        {
          name: "工业无线",
          detail: [
            { name: "无线网络", link: "" },
            { name: "无线通讯", link: "" },
            { name: "无线位置", link: "" },
            { name: "无限分析", link: "" },
          ],
        },
        {
          name: "工业软件",
          detail: [
            { name: "能源管理软件", link: "" },
            { name: "大数据平台", link: "" },
            { name: "GIS地图信息平台", link: "" },
          ],
        },
        {
          name: "测量仪表",
          detail: [
            { name: "流体仪表", link: "" },
            { name: "电力仪表", link: "" },
            { name: "压力仪表", link: "" },
            { name: "温度仪表", link: "" },
            { name: "液位仪表", link: "" },
          ],
        },
      ],
      ziList: [
        {
          name: "咨询",
          detail: [
            { name: "智能工厂设计咨询", link: "" },
            { name: "工业物联园区设计咨询", link: "" },
          ],
        },
        {
          name: "服务",
          detail: [
            { name: "设备安装与运维服务", link: "" },
            { name: "数据分析与校准服务", link: "" },
            { name: "能源与能效诊断服务", link: "" },
          ],
        },
      ],
      zhuanList: [
        { name: "跨学科研发", link: "" },
        { name: "物联", link: "" },
        { name: "工业无线", link: "" },
        { name: "流体测量", link: "" },
      ],
      liaoList: [
        { name: "企业概述", link: "" },
        { name: "企业文化", link: "" },
        { name: "荣誉资质", link: "" },
        { name: "新闻报告", link: "" },
        { name: "合作伙伴", link: "" },
      ],
      jiaList: [
        { name: "社会招聘", link: "" },
        { name: "校园招聘", link: "" },
      ],
      headerFlag: true,
      img1before: require("@assets/img/logob.png"),
      img2before: require("@assets/img/soub.png"),
      img3before: require("@assets/img/daob.png"),
      activeIndex: -1,
      modalFlag: false,
      rotate: false, //控制互转效果
      erweima: require("@assets/img/erma.png"),
      //   banner: require("@assets/img/banner2.jpg"),
      imgList: [
        {
          theme: "卓越的传感器和传感技术",
          content:
            "支持IOT的设备可以让企业做出更明智的商业决策。我们为工厂设备配备卓越的传感器和传感技术，无论是电力、流体动力还是机械动力。通过双方的通力协作，不断努力在生产效率和成本效率方面取得更大的进步。",
          url: require("@assets/img/wl1.png"),
        },
        {
          theme: "数据建模分析",
          content:
            "未经处理的原始数据价值有限。通过对数据的展示和分析，帮助客户降低总体拥有成本，提高效率，最大限度地延长正常运行时间。<br/>我们使用数字模型来模拟现实世界中的实物资产，从而使我们能够在承诺进行大规模资本投资之前快速设计、构建和测试解决方案。",
          url: require("@assets/img/wl2.png"),
        },
        {
          theme: "开放的平台管理",
          content:
            "我们致力于开发一种开放、可扩展和安全的通信平台方法——改变系统、事物、人员和流程之间的交互方式。我们期待与客户的合作伙伴合作，以提高平台的扩展性并简化法规遵从性。",
          url: require("@assets/img/wl3.png"),
        },
      ],
      teList: [
        {
          theme: "分析功能",
          text:
            "我们拥有强大的数字服务分析功能可以在几分钟内生成生产装置的库存列表，信息全透明。基于库存信息，随时为您计算得出当前生产厂优化建议。",
          url: require("@assets/img/te1.png"),
        },
        {
          theme: "自检功能",
          text:
            "生产装置通过健康功能自行报告相关信息，您可以随时随地了解生产装置的运行状况。如果生产装置健康状况不良，您可以发现原因并获取补救措施。",
          url: require("@assets/img/te2.png"),
        },
        {
          theme: "数据归档",
          text:
            "帮助客户收集生产装置信息，所有员工均可随时随地查阅。从而节省了宝贵的搜索时间，减轻了归档工作量。",
          url: require("@assets/img/te3.png"),
        },
        {
          theme: "信息展示",
          text:
            "从现场收集所有过程信息，如：仪表板、历史、追踪图、通知等，并在不同的应用功能中显示相应的信息。",
          url: require("@assets/img/te4.png"),
        },
      ],
      spanFlag: true,
      imgUrl: require("../../assets/img/wl.png"), // 背景图片地址
    };
  },
  methods: {
    handleToHome() {
      //点击图片跳转到首页
      this.$router.push("/");
    },
    enter: function () {
      this.headerFlag = false;
      this.img1before = require("@assets/img/logob.png");
      this.img2before = require("@assets/img/soub.png");
      this.img3before = require("@assets/img/daob.png");
      this.activeIndex = -1;
    },
    leave: function () {
      this.headerFlag = true;
      this.img1before = require("@assets/img/logob.png");
      this.img2before = require("@assets/img/soub.png");
      this.img3before = require("@assets/img/daob.png");
      this.activeIndex = -1;
    },
    selected(index) {
      this.activeIndex = index;
      console.log(this.activeIndex);
    },
    navShow() {
    },
    navNone() {
    },
    afterLoad() {},
    showAll() {
      //打开弹窗
      //点击右上角三条横杠
      this.modalFlag = true;
      // var mo=function(e){e.preventDefault();};
      //   document.body.style.overflow='hidden';
      //   document.addEventListener("touchmove",mo,false);//禁止页面滑动
      // this.$refs.fullpage.api.setAllowScrolling(false, "up,down,left, right");
    },
    handleClose() {
      //关闭弹窗
      this.modalFlag = false;
      // this.$refs.fullpage.api.setAllowScrolling(true, "up,down,left, right");
    },
    zhuan() {
      //旋转模态框叉号
      this.rotate = !this.rotate;
    },
    // 面包屑
    handleHome() {
      this.$router.push("/");
    },
    handleEnter(index) {
      //滑上组件时字体消失 遮罩显示
      // this.spanFlag=false;
      // console.log(index)
      this.imgList[index].spanFlag = false;
      this.imgList[index].maskFlag = true;
    },
    handleLeave(index) {
      // console.log(index)
      this.imgList[index].spanFlag = true;
      this.imgList[index].maskFlag = false;
    },
    //跳往解决方案二级页面
    handleJiejue() {
      this.$router.push("/solution");
    },
  },
};
</script>

<style lang='scss' scoped>
.home {
  width: 100%;
  height: 100%;
  position: relative;
}
.banner {
  width: 100%;
  height: 500px;
  background: url("../../assets/img/wl.png") no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: bottom center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  position: relative;
  div {
    width: 75%;
    margin: 0 auto;
  }
  img {
    width: 100%;
    // height: 500px;
    position: absolute;
    bottom: 0;
    // left: 0;
    // bottom: 0;
    // right: 0;
  }
  span {
    font-size: 26px;
    font-family: YaHei;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    display: block;
    line-height: 44px;
    letter-spacing: 2px;
    // margin-left: 20%;
    &:nth-child(1) {
      font-size: 48px;
      font-family: YaHei;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      letter-spacing: 4px;
    }
  }
}
.main {
  width: 100%;
  background: #f5f5f5;
  .main_center {
    width: 75%;
    height: 100%;
    margin: 0 auto;
    .bread {
      padding-top: 30px;
      font-size: 16px;
      font-family: YaHei;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      cursor: default;
    }
    .title {
      font-size: 48px;
      font-family: YaHei;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      text-align: center;
      padding-top: 104px;
    }
    .text {
      // width: 72%;
      margin: 0 auto;
      font-size: 24px;
      line-height: 44px;
      font-family: YaHei;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      padding-top: 33px;
      text-align: center;
      span {
        display: block;
        &:nth-child(1) {
          margin-bottom: 50px;
        }
      }
    }
    ul {
      width: 100%;
      padding-top: 82px;
      text-align: left;
      padding-bottom: 105px;
      li {
        min-height: 310px;
        width: 100%;
        display: flex;
        // background: pink;
        padding-top: 1%;
        padding-bottom: 1%;
        background-size: 50% 100%;
        background-repeat: no-repeat;
        background-position: left center;
        &:nth-child(2n) {
          background-position: right center !important;
          .introduce {
            margin: 0;
          }
        }
        // justify-content:end;
        // align-items: center;
        // position: relative;
        // height: 307px;
        // padding-bottom: 20px;
        margin-bottom: 80px;
        // &:nth-child(2) {
        //   .image {
        //     right: 0;
        //   }
        //   .introduce {
        //     left: 0;
        //   }
        // }
        .image {
          width: 50%;
          height: 100%;
          overflow: hidden;
          // position: absolute;
          transition: all 0.6s !important;
          // // background: url("../../assets/img/banner1.jpg") no-repeat;
          // background-size: cover;
          // -webkit-background-size: cover;
          // -o-background-size: cover;
          // background-position: center bottom;
          // &:nth-child(1){
          //    background: url("../../assets/img/banner1.jpg") no-repeat;
          // }
          // &:nth-child(2){
          //    background: url("../../assets/img/banner2.jpg") no-repeat;
          // }
          // &:nth-child(3){
          //    background: url("../../assets/img/banner3.jpg") no-repeat;
          // }
          img {
            width: 100%;
          }
          &:hover {
            transform: scale(1.1);
          }
        }
        .introduce {
          // float: right;
          display: flex;
          flex-direction: column;
          justify-content: center;
          width: 52%;
          min-height: 80%;
          background: rgba(255, 255, 255, 1);
          box-sizing: border-box;
          text-align: left;
          padding: 29px 33px 31px 40px;
          margin-left: 48%;
          // position: absolute;
          // right: 0;
          // top: 10%;
          .theme {
            display: block;
            font-size: 30px;
            font-family: Source Han Sans SC;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            margin-bottom: 23px;
          }
          .content {
            font-size: 17px;
            font-family: Source Han Sans SC;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            line-height: 29px;
          }
        }
      }
    }
    .characteristic {
      padding-bottom: 171px;
      p {
        text-align: center;
        font-size: 32px;
        font-family: YaHei;
        font-weight: bold;
        color: #333333;
      }
      .chara_items {
        padding-top: 73px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .chara_item {
          text-align: center;
          width: 248px;
          // margin-right: 145px;
          margin-bottom: 20px;
          &:nth-child(4) {
            margin-right: 0px;
          }
          img {
            margin-bottom: 21px;
          }
          span {
            display: block;
            font-size: 16px;
            font-family: YaHei;
            font-weight: 400;
            color: #343434;
            &:nth-child(1) {
            }
          }
        }
      }
    }
  }
}
</style>
